import React, {useEffect, useState} from 'react';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import DebtorItem from './item/item';
import HeaderBox from './header-box';
import {useSalesmanContext} from '../../../../../context/salesman';
import {IDebtorItem, ISemaphoreValue} from '../../../../../interfaces/dtos';
import {StackParamList} from '../../../../../navigators';
import {getSemaphoreColor} from '../../../../../constants/semaphore';
import InternalTemplate from '../../../../../components/templates/internal';
import {SpinnerModal} from '../../../../../components/modals';
import {EmptyListIcon} from '../../../../../components/icons';
import SemaphoreItem from '../../../client/dashboard/SemaphoreItem';

type ScreenProps = NativeStackScreenProps<StackParamList, 'SalesmanDebtors'>;

const DebtorsScreen = ({navigation, route}: ScreenProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    salesmanPortfolioFilter,
    balances,
    fetchSemaphoreItems,
    semaphoreItems: semaphoreValues,
    fetchDebtorList,
    debtors,
  } = useSalesmanContext();

  const {position} = route.params;
  const [semaphoreValue, setSemaphoreValue] = useState(
    null as ISemaphoreValue | null,
  );

  const getSemaphoreValue = (list: ISemaphoreValue[] | null, point: number) => {
    if (list) {
      return list[point];
    }
    return null;
  };

  const getDebtorList = async (key: string) => {
    setIsLoading(true);
    const value = getSemaphoreValue(semaphoreValues, position);
    setSemaphoreValue(value);
    if (value) {
      await fetchDebtorList(key, salesmanPortfolioFilter);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (position >= 0 && semaphoreValues) {
      const semaphore = getSemaphoreValue(semaphoreValues, position);
      if (semaphore) {
        setSemaphoreValue(semaphore);
        getDebtorList(semaphore.key);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [semaphoreValues, position]);

  useEffect(() => {
    if (semaphoreValues == null) {
      fetchSemaphoreItems(salesmanPortfolioFilter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [semaphoreValues]);

  const handleGoBack = () => {
    navigation.navigate('SalesmanPortfolioDashboard');
  };

  const handleSelectItem = (index: number) => {
    if (debtors) {
      if (semaphoreValue && debtors[index]) {
        navigation.navigate('SalesmanReceivables', {
          key: semaphoreValue.key,
          debtor: debtors[index],
        });
      }
    }

    //navigation.navigate('BalanceDetail', filtered[index]);
  };

  function isOdd(num: number) {
    return num % 2;
  }

  const Content = () => {
    if (isLoading) {
      return <></>;
    }
    if (balances?.length === 0) {
      return <EmptyListIcon />;
    }
    if (debtors) {
      return (
        <>
          {debtors.map((debtor: IDebtorItem, index: number) => {
            return (
              <DebtorItem
                key={`balance-item-${index}`}
                {...debtor}
                onPress={() => handleSelectItem(index)}
                rowType={isOdd(index) ? 'odd' : 'even'}
              />
            );
          })}
        </>
      );
    }

    return <></>;
  };

  const SemaphoreChart = () => {
    if (semaphoreValue) {
      return (
        <Box padding={2}>
          <SemaphoreItem
            {...{
              ...semaphoreValue,
              label: `label-${semaphoreValue.key}`,
              color: getSemaphoreColor(semaphoreValue.key),
            }}
          />
        </Box>
      );
    }

    return <></>;
  };

  const Header = () => {
    if (isLoading) {
      return <></>;
    }
    return <HeaderBox />;
  };

  return (
    <InternalTemplate
      title={'screen-debtors-list-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-resume',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <Box paddingX={3}>
        <SemaphoreChart />
      </Box>
      <Header />
      <Box marginBottom={20}>
        <Content />
      </Box>
    </InternalTemplate>
  );
};
export default DebtorsScreen;
